module.exports = __webpack_public_path__ + "img/parliament-8.394bf8c0.jpg";